export default __webpack_public_path__ + "static/image1-85ffef1aeded98eb038aa40e69b7eb28.png";